module.exports = __webpack_public_path__ + "images/listeninga3bbf817efcbfdc7207dd56e00db6093.gif";